import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';
import {
  Screen,
  Text,
  Input,
  Label,
  Button,
  ButtonUpload,
  File as FileDoc,
  Checkbox,
} from '../../../components';
import documentsService from '../../../services/documents';
import fileService from '../../../services/file';

const {
  defaultStates,
  defaultAlertScreenOnClick,
  defaultModalOnHide,
  baseURL,
} = require('../../../utils/defaults');

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: {
        name: '',
        newName: '',
        describe: 'Selecione o Tipo de documento',
        files_document: [],
        isActive: true,
      },
      ...defaultStates(),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.modalOnHide = this.modalOnHide.bind(this);
    this.body = this.body.bind(this);
    this.footer = this.footer.bind(this);
  }

  modalOnHide() {
    defaultModalOnHide(this);
  }

  alertScreenOnClick() {
    defaultAlertScreenOnClick(this);
  }

  async componentDidMount() {
    this.setState({ loadingState: true });

    const { id } = this.props.match.params;

    if (id !== 'novo') {
      const response = await documentsService.admin.get(id);
      if (response.ok && response.data && response.data.document) {
        this.setState({
          documents: response.data.document,
          newRegister: false,
        });
      } else if (response.ok) {
        this.props.history.push('/gestao/documents/novo');
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  handleChange(id, event) {
    const { documents } = this.state;

    if (id === 'newName') {
      documents[id] = event.target.getContent();
    } else if (id === 'files_document') {
      documents[id] = [event[0]];
    } else if (id === 'removeFileDocument') {
      documents.files_document = [];
      documents.file_id_document = null;
    } else {
      documents[id] = event.target.value;
    }
    this.setState({ documents });
  }

  async handleSubmit() {
    const { newRegister, documents } = this.state;
    this.setState({ loadingState: true });
    documents.name = documents.newName || documents.name;
    delete documents.newName;
    if (newRegister) {
      const response = await documentsService.admin.save(documents);

      if (response.ok) {
        const alertScreenState = {
          title: 'Documento criado com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/documents',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }
    } else {
      const response = await documentsService.admin.edit(documents);

      if (response.ok) {
        const alertScreenState = {
          title: 'Documento alterado com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/documents',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  async handleDelete() {
    this.setState({
      modalState: {
        title: `Remoção de ${this.state.documents.isActive ? 'Documentos' : 'Rascunho'}`,
        text: `Tem certeza que deseja excluir esse${
          this.state.documents.isActive ? 'documento' : 'rascunho'
        }?`,
        toggle: true,
        onHide: () => this.modalOnHide(),
        confirm: 'Sim',
        onClickConfirm: async () => await _handleDelete(),
        danger: true,
        cancel: 'Não',
        onClickCancel: () => this.modalOnHide(),
      },
    });

    const _handleDelete = async () => {
      const {
        documents: { id },
      } = this.state;
      this.setState({ loadingState: true });

      const response = await documentsService.admin.delete(id);

      if (response.ok && response.data) {
        const alertScreenState = {
          title: 'Documento Excluido com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/documents',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }

      this.setState({ loadingState: false });
    };
  }

  async handleUploadFileTiny(file, cb) {
    const response = await fileService.upload({ files: [file] });
    if (response.ok && response.data) {
      const file = response.data;

      cb(`${baseURL()}/api/file/${file.fileId}/${file.slug}`, {
        title: file.slug,
      });
    } else {
      const modalState = {
        title: 'Erro',
        text: response.message,
        toggle: true,
        onHide: this.modalOnHide,
      };

      this.setState({ modalState });
    }
  }

  body() {
    const { documents, modalFile } = this.state;
    const options = [
      { describe: 'Selecione uma opção', value: '' },
      { describe: 'NORMAS', value: 'NORMAS' },
      { describe: 'RESOLUÇÕES', value: 'RESOLUCOES' },
      { describe: 'CIRCULARES', value: 'CIRCULARES' },
      { describe: 'CARTA-CIRCULARES', value: 'CARTA_CIRCULARES' },
      { describe: 'LEGISLAÇÃO', value: 'LEGISLACAO' },
      { describe: 'POLÍTICAS E NORMAS', value: 'POLITICA_E_NORMAS' },
      { describe: 'COMUNICADOS DO FGCOOP', value: 'COMUNICADOS_DO_FGCOOP' },
    ];

    return (
      <>
        <Row align="center">
          <Col>
            <Text title text={'Documentos'} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              label={'Ativo'}
              checked={documents.isActive}
              onClick={() => {
                documents.isActive = !documents.isActive;
                this.setState({ documents });
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} xs={12}>
            <Label text={'Selecione o Tipo de documento'} />
            <Form.Select
              size="lg"
              value={documents.describe}
              onChange={(e) => this.handleChange('describe', e)}>
              {options.map((option, idx) => (
                <option key={idx} value={option.value}>
                  {option.describe}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col sm={12} xs={12}>
            <Input
              value={documents.name}
              label={'Nome'}
              placeholder={'Nome'}
              maxLength={200}
              onChange={(e) => this.handleChange('name', e)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Label text={'Documento:'} />
            <ButtonUpload
              modal
              onClickConfirm={(e) => {
                this.handleChange('files_document', e);
                this.setState({ modalFile: false });
              }}
              modalToggle={modalFile}
              modalTitle={'ADICIONAR DOCUMENTO'}
              modalOnHide={() => this.setState({ modalFile: false })}
              onClick={() => this.setState({ modalFile: true })}
            />
          </Col>
        </Row>
        {documents.files_document.length > 0 ? (
          <Row align="center">
            <Col>
              <Text subTitle text="Documento Adicionado" />
            </Col>
          </Row>
        ) : (
          ''
        )}
        <Row>
          {documents.files_document.map((doc, index) => {
            return (
              <Col md={4} key={index}>
                <FileDoc
                  fileName={doc.fileName ? doc.fileName : doc.name ? doc.name : 'Arquivo sem nome'}
                  fileTitle={doc.fileName ? doc.fileName : doc.name ? doc.name : 'Arquivo sem nome'}
                  onClick={() => this.handleChange('removeFileDocument')}
                  info={doc}
                />
              </Col>
            );
          })}
        </Row>
      </>
    );
  }

  footer() {
    return (
      <>
        <Row align="center">
          {this.state.documents.id ? (
            <Col>
              <Button danger text={'Excluir'} onClick={this.handleDelete} />
            </Col>
          ) : (
            <></>
          )}
          <Col>
            <Button text={'Salvar'} onClick={this.handleSubmit} />
          </Col>
        </Row>
      </>
    );
  }

  render() {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <>
        <Screen
          admin
          body={this.body}
          footer={this.footer}
          modalState={modalState}
          alertScreenState={alertScreenState}
          loadingState={loadingState}
        />
      </>
    );
  }
}

Documents.propTypes = {
  //props
  match: PropTypes.object,
  history: PropTypes.object,
};

export default Documents;
